<template>
  <div class="p-6">
    
    <h5 class="mt-4 mb-3">{{ $t('Decarbonization.EnergyScenarios.LOMParametersEditionTab') }}</h5>
    <vs-row>
      <vs-col vs-w="8">
        <ValidationObserver ref="addMultipleObserver">
          <vs-row>
            <vs-col vs-w="5" class="m-3" >
              <ValidationProvider :name="$t('Decarbonization.EnergyScenarios.EnergySupplyTemplate')" rules="required" v-slot="{ errors }">
                <form-label>{{$t('Decarbonization.EnergyScenarios.EnergySupplyTemplate')}}</form-label>
                <v-select
                  :options="energySupplyTemplates"
                  label="name"
                  :reduce="x => x.id"
                  v-model="selectedEnergySupplyTemplate"
                  class="w-full"
                  name="energySupplyTemplateId"
                />
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
            
            <vs-col  vs-w="5" class="m-3" >
              <ValidationProvider :name="$t('Decarbonization.EnergyScenarios.GridEfficiencyTemplate')" rules="required" v-slot="{ errors }">
                <form-label>{{$t('Decarbonization.EnergyScenarios.GridEfficiencyTemplate')}}</form-label>
                <v-select
                  :options="gridEfficiencyTemplates"
                  label="name"
                  :reduce="x => x.id"
                  v-model="selectedGridEfficiencyTemplate"
                  class="w-full"
                  name="gridEfficiencyTemplateId"
                />
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
          <vs-row>       
            <vs-col vs-justify="flex-start" vs-lg="5" class="m-3" >
              <ValidationProvider :name="$t('Decarbonization.EnergyScenarios.CalculationMethod')" rules="required" v-slot="{ errors }">
                <form-label>{{$t('Decarbonization.EnergyScenarios.CalculationMethod')}}</form-label>
                <v-select
                  :options="calculationMethodEnum"
                  label="name"
                  :reduce="x => x.id"
                  v-model="calculationMethod"
                  class="w-full"
                  name="calculationMethodId"
                />
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
            <vs-col vs-justify="flex-start" vs-lg="5" class="m-3" v-if="requiresComplexityParameter" >
              <ValidationProvider :name="$t('Decarbonization.EnergyScenarios.ComplexityParameter')" rules="required" v-slot="{ errors }">
                <form-label>{{$t('Decarbonization.EnergyScenarios.ComplexityParameter')}}</form-label>
                <v-select
                  :options="complexityParameters"
                  label="name"
                  :reduce="x => x.id"
                  v-model="selectedComplexityParameter"
                  class="w-full"
                  name="complexityParameterId"
                />
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </vs-col>
          </vs-row>
        
        </ValidationObserver>
      </vs-col>
      <vs-col vs-w="4">
        <vs-row vs-type="flex" vs-justify="flex-end">
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
            <vs-button type="border" class="mr-3" icon-pack="feather" icon="icon-save" @click="sendData">{{ $t('Save') }}</vs-button>
            <vs-button type="border" class="mr-3" color="danger" @click="cancelEdit">{{ $t('Cancel') }}</vs-button>
            <vs-button v-if="canUpload" type="border" class="mr-3" icon-pack="feather" icon="icon-upload"  @click="openUploadPopup" v-b-tooltip.hover :title="$t('Upload')">{{ $t('Upload') }}</vs-button>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row>
      <EnergySimulation
        v-if="enableEnergySimulation"
        :complexityParameter="selectedComplexityParameter"
        :calculationMethod="calculationMethod"
        :lomEntityId="value.selectedParameter.lomEntityId"
        :lomScenarioTypeId="value.selectedParameter.lomScenarioTypeId"
        :lomVersionId="value.selectedParameter.lomVersionId"
        :lomParameterId="value.selectedParameter.id"
        :yearlyEnergyDemand="value.selectedParameter.yearlyEnergyDemand"
        :yearlyEmissions="value.selectedParameter.yearlyEmissions"
        :energySupplyTemplateId="selectedEnergySupplyTemplate"
        :gridEfficiencyTemplateId="selectedGridEfficiencyTemplate"
        :externalLomId="value.selectedParameter.externalLOMId"
        :createNew="isNew"
        :key="energySimulationKey"
        />
    </vs-row>

    <vs-popup class="uploadPopup" :title="$t('Decarbonization.EnergyScenarios.UploadFile')" :active.sync="uploadPopupActive">
      <div class="p-6" v-if="!isNew">
        <form data-vv-scope="tab2">
          <vs-row class="mb-5">
            <vs-col class="text-warning" vs-w="12">
              <feather-icon
                    icon="AlertTriangleIcon"
                    class="mr-3"
                  />
                {{ $t('Decarbonization.EnergyScenarios.UploadWarning') }}
            </vs-col>
          </vs-row>
          <vs-row >
            <vs-col vs-w="12">
              <input id="uploadInputFile" type="file" accept=".csv" v-on:change="getFile($event)">
              <div class="mb-1">
              </div>  
              <validation-message v-if="showInvalidFileError">{{ $t('Decarbonization.EnergyScenarios.UploadInvalidFileError') }}</validation-message>
            </vs-col>
          </vs-row>
          <vs-row class="mb-6" >
            <vs-col vs-w="6">
              <small><a target="_blank" href="https://agnicoeagle.sharepoint.com/:x:/s/GRP_CSD_Data_Solution/EUBlUjbW-UNIrJu7wk26juoBly150Pe3YsVPrujzU6Ba_g?e=ikCjFi&download=1">{{$t('Decarbonization.EnergyScenarios.UploadTemplateTotalEnergyFile')}}</a></small><br>
              <small><a target="_blank" href="https://agnicoeagle.sharepoint.com/:x:/s/GRP_CSD_Data_Solution/EY8Nl4zaCCtKloxYKArK2xoB7h2yzAVurjVCtvtqOXgxPA?e=XukrmA&download=1">{{$t('Decarbonization.EnergyScenarios.UploadTemplateMovedTonsFile')}}</a></small>
            </vs-col>
          </vs-row>
        </form>
        <div>
          <vs-row class="mb-3" vs-type="flex" vs-justify="flex-end">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <vs-button :disabled="!file" class="mr-5" @click="uploadFile">{{ $t('Submit') }}</vs-button>
              <vs-button type="border" color="danger" @click="cancelUpload">{{ $t('Cancel') }}</vs-button>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="12">
              <vs-progress v-show="uploadInProgress" indeterminate color="primary">primary</vs-progress>
            </vs-col>
          </vs-row>
        </div>
      </div>
      <div v-else>
        {{ $t('Decarbonization.EnergyScenarios.ParameterMustBeCreated') }}
      </div>
    </vs-popup>
  </div>
</template>

<script>

import vSelect from 'vue-select';
import EnergySimulation from './EnergySimulation.vue';
import CalculationMethodEnum from '@/app/bsg/decarbonization/enums/CalculationMethod.js'

import {
  FormLabel,
  ValidationMessage
} from "@/app/shared/components";

export default {
  components: {
    FormLabel,    
    vSelect,
    ValidationMessage,
    EnergySimulation
  },
  props: ['value'],
  data() {
    return {
      isNew: true,
      energySupplyTemplates: [],
      selectedEnergySupplyTemplate: '',
      
      gridEfficiencyTemplates: [],
      selectedGridEfficiencyTemplate: '',
      
      complexityParameters: [],
      selectedComplexityParameter: '',

      calculationMethodEnum: [
        { name: this.$t("Decarbonization.CalculationMethodEnum." + CalculationMethodEnum.CorrelationByComplexity), id: CalculationMethodEnum.CorrelationByComplexity },
        { name: this.$t("Decarbonization.CalculationMethodEnum." + CalculationMethodEnum.ManualImportOfTotalEnergy), id: CalculationMethodEnum.ManualImportOfTotalEnergy },
        { name: this.$t("Decarbonization.CalculationMethodEnum." + CalculationMethodEnum.ManualImportOfMovedTons), id: CalculationMethodEnum.ManualImportOfMovedTons }
      ],
      calculationMethod: '',

      enableEnergySimulation: false,
      energySimulationKey: 0,
      file: "", 
      uploadPopupActive: false,
      showInvalidFileError: false,
      uploadInProgress: false
    };
  },

  created() {
    this.refreshEnergySupplyTemplatesList();
    this.refreshGridEfficiencyTemplatesList();
    this.refreshComplexityParametersList();

    this.isNew = this.value.createNew;

    if (!this.isNew) {
      this.selectedEnergySupplyTemplate = this.value.selectedParameter.energySupplyTemplateId;
      this.selectedGridEfficiencyTemplate = this.value.selectedParameter.gridEfficiencyTemplateId;
      this.selectedComplexityParameter = this.value.selectedParameter.complexityParameterId;
      this.calculationMethod = this.value.selectedParameter.calculationMethod;
    } 

    this.$nextTick(() => { this.enableEnergySimulation = true; });
  },

  computed: {
    valid() {
      const validEntity = (x) => x !== null && x !== '' && x > 0;
      const validEnum = (x) => x !== null && x !== '' && x >= 0;
      const energySupplyTemplateValid = validEntity(this.selectedEnergySupplyTemplate);
      const gridEfficiencyTemplateValid = validEntity(this.selectedGridEfficiencyTemplate);
      const complexityParameterValid = !this.requiresComplexityParameter || validEntity(this.selectedComplexityParameter);
      const calculationMethodValid = validEnum(this.calculationMethod);
      return energySupplyTemplateValid && gridEfficiencyTemplateValid && complexityParameterValid && calculationMethodValid;
    },
    canUpload() {
      return !this.isNew && (this.calculationMethod === CalculationMethodEnum.ManualImportOfTotalEnergy || this.calculationMethod === CalculationMethodEnum.ManualImportOfMovedTons);
    },
    requiresComplexityParameter() {
      return this.calculationMethod !== CalculationMethodEnum.ManualImportOfTotalEnergy;
    }
  },

  watch: {
    selectedEnergySupplyTemplate() {
      this.handleValueChange();
    },
    selectedGridEfficiencyTemplate() {
      this.handleValueChange();
    },
    selectedComplexityParameter() {
      this.handleValueChange();
    },
    calculationMethod() {
      this.handleValueChange();
      if (this.calculationMethod === CalculationMethodEnum.ManualImportOfTotalEnergy) {
        this.selectedComplexityParameter = null;
      }
    }
  },

  methods: {
    handleValueChange() {
      // TODO: cleanup
      // if (this.value.createNew && this.valid) {
      //   this.sendData();
      //   // eslint-disable-next-line
      //   return;
      // }
    },
    refreshEnergySupplyTemplatesList() {
      this.$vs.loading();
      this.$cqrsGet("Cashflow/Decarbonization/EnergySupplyTemplates/FindAll/")
        .then((response) => {
          const model = response.data.model;
          this.energySupplyTemplates = model.map(x => ({
            id: x.id,
            name: x.name
          }));
        })
        .finally(() => this.$vs.loading.close());
    },
    refreshGridEfficiencyTemplatesList() {
      this.$vs.loading();
      this.$cqrsGet("Cashflow/Decarbonization/GridEfficiencyTemplates/FindAll/")
        .then((response) => {
          const model = response.data.model;
          this.gridEfficiencyTemplates = model.map(x => ({
            id: x.id,
            name: x.name
          }));
        })
        .finally(() => this.$vs.loading.close());
    },
    refreshComplexityParametersList() {
      this.$vs.loading();
      this.$cqrsGet("Cashflow/Decarbonization/ComplexityParameters/FindAll/")
        .then((response) => {
          const model = response.data.model;
          this.complexityParameters = model.map(x => ({
            id: x.id,
            name: x.name
          }));
        })
        .finally(() => this.$vs.loading.close());
    },
    cancelEdit() {
      this.$emit('cancelLOMEdit');
    },
    sendData() {
      if (!this.valid) {
        this.$vs.notify({
          color: "danger",
          title: this.$t("Decarbonization.EnergyScenarios.DataNotCompleteTitle"),
          text: this.$t("Decarbonization.EnergyScenarios.DataNotCompleteText")
        })
        return;
      }

      this.$vs.loading();

      // eslint-disable-next-line
      let lomParameter = {}
      lomParameter.energyScenarioId = this.value.energyScenarioId;
      lomParameter.externalLomId = this.value.selectedParameter.externalLOMId;
      lomParameter.lomEntityId = this.value.selectedParameter.lomEntityId;
      lomParameter.lomScenarioTypeId = this.value.selectedParameter.lomScenarioTypeId;
      lomParameter.lomVersionId = this.value.selectedParameter.lomVersionId;
      lomParameter.calculationMethod = this.calculationMethod;
      lomParameter.energySupplyTemplateId = this.selectedEnergySupplyTemplate;
      lomParameter.gridEfficiencyTemplateId = this.selectedGridEfficiencyTemplate;
      lomParameter.complexityParameterId = this.selectedComplexityParameter;
      
      if (this.isNew) {
        this.$cqrsPost("Cashflow/Decarbonization/EnergyScenarios/CreateLOMParameter/", { lomParameter })
          .then((response) => {
            const model = response.data.model;
            this.$notifySaveSuccess();
            this.$emit('input', {
              selectedParameter: model,
              createNew: false,
              energyScenarioId: this.value.energyScenarioId
            });
            this.isNew = false;
            this.energySimulationKey++;
          }).finally(() => this.$vs.loading.close());
      } else {
        lomParameter.id = this.value.selectedParameter.id;
        lomParameter.displayName = this.value.selectedParameter.displayName;
        this.$cqrsPost("Cashflow/Decarbonization/EnergyScenarios/EditLOMParameter/", { lomParameter })
          .then((response) => {
            const model = response.data.model;
            this.$notifySaveSuccess();
            this.$emit('input', {
              selectedParameter: model,
              createNew: false,
              energyScenarioId: this.value.energyScenarioId
            });
            this.energySimulationKey++;
          }).finally(() => this.$vs.loading.close());
      }
    },    
    openUploadPopup() {
      this.uploadPopupActive = true;
    },
    getFile(event) {
      if (event.target.files.length > 0) {
        if (event.target.files[0].name !== null && event.target.files[0].name !== "undefined") {
          if (event.target.files[0].name.search(".csv") !== -1) {
            this.file = event.target.files[0];
            this.showInvalidFileError = false;
          }
          else {
            this.showInvalidFileError = true;
          }
        }
      }
    },
    uploadFile() {
      if (!this.isNew) {
        this.sendData(); // --> Bugfix for #5130
        
        const formData = new FormData();
        formData.append("files", this.file);
        formData.append("lomParameterId", this.value.selectedParameter.id);

        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };

        this.uploadInProgress = true;
        this.$cqrsPost('Cashflow/Decarbonization/EnergyScenarios/upload/', formData, config)
          .then((response) => {
            this.$notifySuccess(this.$t('Decarbonization.EnergyScenarios.UploadSuccess'));
            const model = response.data.model;
            this.$notifySaveSuccess();
            this.$emit('input', {
              selectedParameter: model,
              createNew: false,
              energyScenarioId: this.value.energyScenarioId
            });
            this.energySimulationKey++;
          }).catch((error) => {
            if (error.response.status === 400) {
              this.$vs.notify({
                color: "danger",
                title: this.$t("Decarbonization.EnergyScenarios.UploadFails"),
                text:  error.response.data.Message });
            }            
          }).finally(() => {
            document.getElementById("uploadInputFile").value = "";            
            this.uploadInProgress  = false;
            this.uploadPopupActive = false;
            this.file = null;
          })
      }
    },
    cancelUpload() {
      document.getElementById("uploadInputFile").value = "";
      this.file = null;
      this.uploadPopupActive = false;
    }
  }
};
</script>
<style scoped>
  .hideThis {
    visibility: hidden;
  }
</style>